import Vue from 'vue'

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;
let loaidngList = [];
function startLoading(config) {
    var target = config ? config.loading : undefined;
    if (!target) return;
    if (typeof target == "boolean") {
        var loadingText = "加载中...";
        if (config.loadingText) loadingText = config.loadingText;
        loading = Vue.prototype.$loading({
            lock: true,
            text: loadingText,
            spinner: 'el-icon-loading',
            target: document.querySelector('.loading-area')//设置加载动画区域
        });
    } else {
        loaidngList.push(Vue.prototype.$loading({
            lock: true,
            spinner: 'el-icon-loading',
            target: target.$el ? target.$el : target
        }))
    }
}

function endLoading(config) {
    var target = config ? config.loading : undefined;
    if (!target) return;
    if (typeof target == "boolean") {
        loading.close();
    } else {
        var temp = loaidngList.filter(item => item.target == (target.$el ? target.$el : target));
        if (temp.length) {
            var index = loaidngList.indexOf(temp[0]);
            temp[0].close();
            loaidngList.splice(index, 1);
        }
    }
}

//声明一个对象用于存储全屏loading的请求个数
let needLoadingRequestCount = 0;

export function tryShowLoading(config) {
    if (config && config.loading != undefined && config.loading) {
        if (typeof config.loading == "boolean") {
            if (config.loading) {
                if (needLoadingRequestCount === 0) {
                    startLoading(config);
                }
                needLoadingRequestCount++;
            }
        } else {
            startLoading(config);
        }
    }
};

export function tryHideLoading(config) {
    if (config && config.loading != undefined && config.loading) {
        if (typeof config.loading == "boolean") {
            if (config.loading) {
                if (needLoadingRequestCount <= 0) return;
                needLoadingRequestCount--;
                if (needLoadingRequestCount === 0) {
                    endLoading(config);
                }
            }
        } else {
            endLoading(config);
        }
    }
};
